import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'
import SVG from '../SVG/SVG'
import Accordion from '../Accordion'

const useStyles = createUseStyles({
  containerFooter: {
    backgroundColor: '#C8102E',
    backgroundImage:
      'url(/themes/dollar/assets/images/footerbg1.png),url(/themes/dollar/assets/images/footerbg2.png)',
    padding: '80px 0',
    display: 'block',
    backgroundRepeat: 'no-repeat, no-repeat',
    backgroundPosition: 'left bottom, right bottom',
    '& > div': {
      margin: '0 auto',
      width: '100%',
      maxWidth: '1220px',
    },
  },
  gridle: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gridGap: '30px',
    marginBottom: '40px',
    '@media (max-width: 700px)': {
      gridTemplateColumns: '1fr',
      boxSizing: 'border-box',
      marginLeft: 15,
      marginRight: 15,
    },
  },
  text: {
    fontWeight: 300,
    color: '#fff',
    marginTop: '33px',
    fontSize: '12px',
    lineHeight: '22px',
    '& span': {
      fontWeight: 500,
      display: 'inline-block',
      marginRight: '10px',
    },
    '& a': {
      color: '#fff',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
        textDecorationThickness: '2.4px',
        textDecorationColor: '#8C0B20',
        textUnderlineOffset: '0.2rem',
      },
    },
  },
  socialMedia: {
    fontWeight: 300,
    color: '#fff',
    marginTop: '33px',
    fontSize: '12px',
    lineHeight: '18px',
    '@media (min-width: 700px)': {
      paddingTop: 15,
    },
    '& span': {
      fontWeight: 500,
      display: 'block',
      marginRight: '0',
      marginBottom: '10px',
    },
    '& a': {
      display: 'inline-flex',
      marginRight: 6,
      width: 28,
      height: 28,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#fff',
      borderRadius: '50%',
      '&:hover': {
        backgroundColor: '#8C0B20',
      },
    },
  },
  title: {
    fontSize: '16px',
    fontWeight: 700,
    marginBottom: '20px',
    color: '#fff',
  },
  list: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    '& li': {
      marginBottom: 10,
      '& a': {
        fontSize: '12px',
        lineHeight: '12px',
        color: '#fff',
        fontWeight: 300,
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
          textDecorationThickness: '1.4px',
          textUnderlineOffset: '0.2rem',
        },
      },
    },
  },
  hideonmobile: {
    '@media (max-width: 700px)': {
      display: 'none !important',
    },
  },
  mobilefooter: {
    '@media (min-width: 700px)': {
      display: 'none !important',
    },
  },
  footerbottom: {
    fontSize: '12px',
    color: 'white',
    paddingTop: '15px',
    borderTop: '1px solid #fff',
    fontWeight: 300,
    display: 'flex',
    '& div:nth-child(2)': {
      marginLeft: 'auto',
      opacity: 0.8,
    },
    '& a': {
      color: '#fff',
    },
    '@media (max-width: 700px)': {
      margin: '0 15px',
    },
  },
})

export const Footer = ({ navLinks, WebSettings }) => {
  const classes = useStyles()

  return (
    <footer>
      <div className={classes.containerFooter}>
        <div>
          <div className={classes.gridle}>
            <div>
              <img
                src="/themes/dollar/assets/images/whiteLogo.png"
                width="120"
                height="43"
                alt="Dollar"
              />
              <div className={classes.text}>
                <span>For Reservations</span>
                <a href={`tel:${WebSettings.ForReservations}`}>{WebSettings.ForReservations}</a>
              </div>
              <div className={classes.text} style={{ marginTop: '10px' }}>
                <span>Customer Service</span>
                <a href={`tel:${WebSettings.CustomerServiceNumber}`}>
                  {WebSettings.CustomerServiceNumber}
                </a>
              </div>
              <div className={classes.socialMedia} style={{ marginTop: '10px' }}>
                <span>Social</span>
                {WebSettings.Linkedin && (
                  <a href={WebSettings.Linkedin} aria-label="Linkedin">
                    <SVG name={'Linkedin'} width={18} height={18} colorOne={'#C8102E'} />
                  </a>
                )}
                {WebSettings.Facebook && (
                  <a href={WebSettings.Facebook} aria-label="Facebook">
                    <SVG name={'Facebook'} width={18} height={18} colorOne={'#C8102E'} />
                  </a>
                )}
                {WebSettings.Twitter && (
                  <a href={WebSettings.Twitter} aria-label="Twitter">
                    <SVG name={'Twitter'} width={18} height={18} colorOne={'#C8102E'} />
                  </a>
                )}
                {WebSettings.Youtube && (
                  <a href={WebSettings.Youtube} aria-label="Youtube">
                    <SVG name={'Youtube'} width={18} height={18} colorOne={'#C8102E'} />
                  </a>
                )}
                {WebSettings.Instagram && (
                  <a href={WebSettings.Instagram} aria-label="Instagram">
                    <SVG name={'Instagram'} width={18} height={18} colorOne={'#C8102E'} />
                  </a>
                )}
              </div>
            </div>
            {navLinks.map((nav, i) => (
              <div className={classes.hideonmobile} key={i}>
                <div className={classes.title}>{nav.header}</div>
                <ul className={classes.list}>
                  {nav.items.map((item, x) => (
                    <li key={x}>
                      <a href={item.href}>{item.text}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <div className={classes.mobilefooter}>
              {navLinks.map((nav, outsideIndex) => (
                <Accordion key={`h-l-m-1-${outsideIndex}`} title={nav.header}>
                  <ul className={classes.list}>
                    {nav.items.map((item, insideIndex) => (
                      <li key={insideIndex}>
                        <a href={item.href}>{item.text}</a>
                      </li>
                    ))}
                  </ul>
                </Accordion>
              ))}
            </div>
          </div>
          <div className={classes.footerbottom}>
            <div dangerouslySetInnerHTML={{ __html: WebSettings.FooterCopyRight }} />
            <div>{WebSettings.FooterACN}</div>
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer.propTypes = {
  headers: PropTypes.array,
  columns: PropTypes.array,
  socialLinks: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      href: PropTypes.string,
    }),
  ),
  ctaText: PropTypes.string,
  ctaURI: PropTypes.string,
  termsURI: PropTypes.string,
  privacyURI: PropTypes.string,
}

export default Footer
